function handleSizeClick(sectionId, is_value_available) {
  const addToCartButton = document.querySelector(`button[data-id="${sectionId}"]`);
  if (!addToCartButton) return;
  
  const spanEl = addToCartButton.querySelector('span');
  if (!spanEl) return;
  
  if (is_value_available) {
    addToCartButton.removeAttribute('disabled');
    spanEl.textContent = addToCartButton.dataset.addToCart;
  } else {
    addToCartButton.setAttribute('disabled', '');
    spanEl.textContent = addToCartButton.dataset.soldOut;
  }
}

// Helper function to open variant picker details
function openVariantPicker(sectionId) {
  const variantPickerDetails = document.getElementById(`variant-picker-details-${sectionId}`);
  if (variantPickerDetails && !variantPickerDetails.hasAttribute('open')) {
    variantPickerDetails.setAttribute('open', '');
    variantPickerDetails.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}

// Helper function to check if button shows "select size"
function isSelectSizeButton(button) {
  const spanEl = button.querySelector('span');
  const selectSizeText = button.dataset.selectSize;
  
  if (!spanEl || !selectSizeText) return false;
  
  const buttonText = spanEl.textContent.trim().toLowerCase();
  const selectSizeTextLower = selectSizeText.toLowerCase();
  
  return buttonText === selectSizeTextLower;
}

// Intercept form submission when button says "select size" and open details instead
document.addEventListener('DOMContentLoaded', function() {
  const submitButtons = document.querySelectorAll('button[data-select-size]');
  
  submitButtons.forEach(submitButton => {
    const form = submitButton.closest('form');
    if (!form) return;
    
    const sectionId = submitButton.dataset.id;
    
    // Handle button click
    submitButton.addEventListener('click', function(e) {
      if (isSelectSizeButton(submitButton) && submitButton.hasAttribute('disabled')) {
        e.preventDefault();
        e.stopPropagation();
        openVariantPicker(sectionId);
        return false;
      }
    });
    
    // Handle form submit as fallback (capture phase to intercept before product-form handler)
    form.addEventListener('submit', function(e) {
      if (isSelectSizeButton(submitButton)) {
        e.preventDefault();
        e.stopPropagation();
        openVariantPicker(sectionId);
        return false;
      }
    }, true);
  });
});